// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TimeFilledSvg from "@fishx/icons-svg/es/asn/TimeFilled";
import FishxIcon from '../components/FishxIcon';

var TimeFilled = function TimeFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TimeFilledSvg
  }));
};

TimeFilled.displayName = 'TimeFilled';
export default React.forwardRef(TimeFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TimeFilled.js
// module id = 4257
// module chunks = 0